/**
 * Client branding configuration based on URL/subdomain
 * Add new clients here as they are onboarded
 */

const clientConfigs = {
  // Alist Security
  Alist: {
    companyName: 'Alist Security',
    logoUrl: 'https://www.alistsecurity.com/_next/image?url=%2Fimages%2Falist-security-logo.png&w=256&q=75',
    primaryColor: '#1976d2',
    accentColor: '#4caf50',
    fromEmail: 'candispatch@streamdata.com',
    fromName: 'Alist Security',
    emailSubject: 'Alist Security: Activity Report',
    companyAddress: '5920 1a St SW #506, Calgary, AB T2H 0G3',
    websiteUrl: 'https://www.alistsecurity.com/',
    phone: '+1 844-585-9595',
  },
  // Stream Data Systems (default/fallback)
  sds: {
    companyName: 'STREAM',
    logoUrl: 'https://streamdata.com/canappsv3/assets/stream-3771cb3f.png',
    primaryColor: '#1976d2',
    accentColor: '#4caf50',
    fromEmail: 'candispatch@streamdata.com',
    fromName: 'Stream',
    emailSubject: 'Stream Data: Activity Report',
    companyAddress: 'Calgary, Alberta',
    websiteUrl: 'https://streamdata.com',
    phone: '',
  },
  // Add more clients as needed:
  // clientname: { ... }
};

/**
 * Detects client from current URL/subdomain
 * Examples:
 *   lnn.cantrack.com -> 'lnn'
 *   cantrack.com/lnn -> 'lnn' (path-based)
 *   localhost:3000 -> 'can' (default)
 */
const detectClientFromUrl = () => {
  const hostname = window.location.hostname.toLowerCase();

  // Check for Alist domains
  if (
    hostname === 'alist.test.streamdata.com' ||
    hostname === 'alist.dev.streamdata.com' ||
    hostname === 'alist.apps.streamdata.com' ||
    hostname.includes('alist')
  ) {
    return 'Alist';
  }

  // Default to SDS/Stream
  return 'sds';
};

/**
 * Gets the branding configuration for the current client
 * @returns {Object} Client branding config
 */
export const getClientBranding = () => {
  const clientKey = detectClientFromUrl();
  return clientConfigs[clientKey] || clientConfigs.sds;
};

/**
 * Gets branding for a specific client key
 * @param {string} clientKey - The client identifier
 * @returns {Object} Client branding config
 */
export const getBrandingByKey = (clientKey) => {
  return clientConfigs[clientKey] || clientConfigs.sds;
};

export default getClientBranding;
